import React from "react";
import { useNavigate } from "react-router-dom";
import LegacyBar from "./legacyBar";
import { toShellUser } from "../shellChrome";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { logoutUser } from "../../../../store/thunks/authenticationThunk";
import { logout } from "../../../../store/features/authentication/authenticationSlice";
import { portalManagementReset } from "../../../../store/features/portalManagement/portalManagementSlice";
import { systemManagementReset } from "../../../../store/features/systemManagement/systemManagementSlice";
import { persistor } from "../../../../store";

/**
 * ── LEGACY SHELL — SCHEDULED FOR DELETION ──────────────────────────────────
 *
 * The old `header.tsx` always rendered something: the marketing bar when signed
 * out, the navy greeting bar when signed in. The refactor deleted the signed-in
 * branch, so a signed-in user landing on /login saw no header at all. This puts
 * it back for the legacy theme only.
 *
 * Empty nav on purpose — no tab strip and no Portal Management button, which is
 * what the original showed here.
 */
const LegacyAuthHeader = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAppSelector((s: any) => s.authentication);

  const handleLogout = () => {
    dispatch(logoutUser({ user_index: user?.client_user_index }));
    dispatch(portalManagementReset());
    dispatch(systemManagementReset());
    dispatch(logout());
    persistor.purge();
    navigate("/login");
  };

  return (
    <LegacyBar
      nav={{
        archetype: "portfolio",
        groups: [],
        otherPrograms: [],
        canSwitchContext: false,
        showSystemManagement: false,
        defaultItemId: ""
      }}
      selectedItemId=""
      onSelectItem={() => {}}
      variant="client"
      user={toShellUser(user)}
      onOpenSystemManagement={() => navigate("/systemManagement")}
      onLogout={handleLogout}
    />
  );
};

export default LegacyAuthHeader;
